module.exports = __webpack_public_path__ + "static/img/currency.00642618.png";